import { render, staticRenderFns } from "./ToothFocusButtons.vue?vue&type=template&id=3c01671c&scoped=true&"
import script from "./ToothFocusButtons.vue?vue&type=script&lang=js&"
export * from "./ToothFocusButtons.vue?vue&type=script&lang=js&"
import style0 from "./ToothFocusButtons.vue?vue&type=style&index=0&id=3c01671c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c01671c",
  null
  
)

export default component.exports